import { i18nPrepareDocumentForRender } from 'i18n';

export function bootstrap() {
    i18nPrepareDocumentForRender();
}
